export function getTotalYearsOfExperience(dateRangeStr,displayStyle) {
  const match = dateRangeStr.match(/(?:(\d+)\s*years?)?\s*(?:(\d+)\s*months?)?/i);
  const years = match?.[1] ? parseInt(match[1], 10) : 0;
  const months = match?.[2] ? parseInt(match[2], 10) : 0;

  if (displayStyle) {
    // Just concatenate for "2.9" style
    return parseFloat(`${years}.${months}`);
  } else {
    // Accurate decimal years
    return parseFloat((years + months / 12).toFixed(1));
  }
}

export function toNumber(value) {
  if (typeof value !== "string") return NaN;

  // Remove all non-digit, non-dot, non-minus characters (keeps decimals and negative signs)
  const cleaned = value.replace(/[^0-9.-]+/g, "");

  const num = Number(cleaned);

  return isNaN(num) ? 0 : num; // fallback to 0 if it's not a number
}

export const capitalizeSentence = (text = "") => {
  const trimmed = text?.trim();
  if (!trimmed) return text;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};